import { Bell } from "lucide-react";
import { useNotification }
from "./useNotification";

export default function NotificationBell() {

  const { notifications } =
    useNotification();

  const unreadCount =
    notifications.filter(
      (n) => !n.read
    ).length;

  return (
    <div className="relative">

      <Bell size={24} />

      {unreadCount > 0 && (
        <span
          className="
          absolute
          -top-2
          -right-2
          bg-red-500
          text-white
          rounded-full
          px-2
          text-xs"
        >
          {unreadCount}
        </span>
      )}

    </div>
  );
}